import { RootState } from '../storeTypes';

export const getIsExtensionModeSelector = (state: RootState) => state.emrState.isExtensionMode;

export const getExtensionPageSelector = (state: RootState) => state.emrState.extensionPage;

export const getExtensionAvailableActionsSelector = (state: RootState) =>
  state.emrState.availableActions;

export const getExtensionStatusSelector = (state: RootState) => state.emrState.extensionStatus;
